import { Box } from "@mui/material";
import React from "react";
import { CopyToolButton } from "source/components/framework/Button/CopyToolButton";
import { EditToolButton } from "source/components/framework/Button/EditToolButton";
import { PasteToolButton } from "source/components/framework/Button/PasteToolButton";

interface ListIconButtonsPermissionProps {
  editTooltip?: string;
  copyTooltip?: string;
  pasteTooltip?: string;
  editDisabled?: boolean;
  copyDisabled?: boolean;
  pasteDisabled?: boolean;
  onEdit?: () => void;
  onCopy?: () => void;
  onPaste?: () => void;
}

export const ListIconButtonsPermission = ({
    editTooltip,
    copyTooltip,
    pasteTooltip,
    editDisabled,
    copyDisabled,
    pasteDisabled,
    onEdit,
    onCopy,
    onPaste,
}: ListIconButtonsPermissionProps) => (
    <Box sx={{ marginLeft: ".5rem" }}>
        {onEdit && (
            <EditToolButton tooltip={editTooltip} disabled={editDisabled} onClick={onEdit} />
        )}
        {onCopy && (
            <CopyToolButton tooltip={copyTooltip} disabled={copyDisabled} onClick={onCopy} />
        )}
        {onPaste && (
            <PasteToolButton tooltip={pasteTooltip} disabled={pasteDisabled} onClick={onPaste} />
        )}
    </Box>
);
